import { Component, Input } from '@angular/core';
import { Day, Flight, Segment } from 'src/main/webapp/assets/models/iter.model';

/**ToDo Documentazione */
@Component({
  selector: 'app-flights',
  styleUrls: ['./flights.component.scss'],
  templateUrl: './flights.component.html'
})
export class FlightsComponent {
  @Input() public day: any;
  /** Tenant `enableFlightPassengers`: mostra i nomi passeggeri del volo (assente/false ⇒ invariato). */
  @Input() public enableFlightPassengers: boolean = false;
  stopovers: any = [];
  isCollapsed: boolean = false;
  state: any = sessionStorage.getItem('state');

  public getFirstSegment(flight: Flight){
    return flight.segments[0];
  }

  public getLastSegment(flight: Flight){
    return flight.segments[flight.segments.length - 1];
  }

  public showLineAfter(day: Day): boolean {
    return (!!day.transfers || !!day.hotels || !!day.optionals) && !day.isLastDay;
  }

  public getStopovers(segments: any): number {
    return segments.length - 1;
  }

  public isDirect(segments: any): boolean {
    return segments.length === 1;
  }

  public getScali(segments: any): any {
    
    let stopovers = [];
    for (let value of segments) {      
      stopovers.push(value);
    }
    
    return stopovers;
  }

  calculateLayoverDuration(segments: any[], index: number) {
    const prevArrival = new Date(segments[index - 1].arrival.date + 'T' + segments[index - 1].arrival.hour);
    const currDeparture = new Date(segments[index].departure.date + 'T' + segments[index].departure.hour);

    const totalMinutes = Math.round((currDeparture.getTime() - prevArrival.getTime()) / (1000 * 60));

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}H ${minutes}min`;
  }

  public getTotalPassengers(flight: Flight): number {
    return (flight.adults || 0) + (flight.children || 0) + (flight.infants || 0);
  }

  /** Logo compagnia del volo (primo segmento), per la nuova card. */
  public getAirlineLogo(flight: Flight): string {
    const code = this.getFirstSegment(flight)?.marketingAirline?.code;
    return code ? `https://www.gstatic.com/flights/airline_logos/70px/${code}.png` : '';
  }

  /** Nome compagnia del volo (primo segmento), per l'alt del logo. */
  public getAirlineName(flight: Flight): string {
    const segment = this.getFirstSegment(flight);
    return segment?.operatingAirline?.name || segment?.marketingAirline?.name || '';
  }

  /** Numero del volo (`codice compagnia + numero`), per la nuova card. */
  public getFlightNumber(flight: Flight): string {
    const segment = this.getFirstSegment(flight);
    if (!segment) {
      return '';
    }
    return `${segment.marketingAirline?.code || ''} ${segment.flightNumber || ''}`.trim();
  }

  /** Nomi passeggeri di tutti i segmenti del volo, trim + dedup, scartando le voci vuote. */
  public getFlightPassengers(flight: Flight): string[] {
    const names = (flight?.segments || []).reduce((acc: string[], segment: Segment) => {
      const passengers = Array.isArray(segment?.passengersData) ? segment.passengersData : [];
      return acc.concat(passengers.map((name: string) => `${name}`.trim()));
    }, []);

    return Array.from(new Set(names.filter((name: string) => !!name)));
  }

  public getFlightDuration(flight: Flight): string {
    if (flight.totalDuration) {
      return flight.totalDuration;
    }
    if (flight.totalDurationWithLand) {
      return flight.totalDurationWithLand;
    }

    let totalMinutes = 0;
    for (const segment of flight.segments) {
      if (segment.duration) {
        totalMinutes += this.parseDurationToMinutes(segment.duration);
      }
    }

    if (totalMinutes === 0) {
      return '';
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}H ${minutes}min`;
  }

  private parseDurationToMinutes(duration: string): number {
    if (!duration) {
      return 0;
    }

    // Gestisce formati tipo "2h 30m", "2H 30min", "2:30", "150min"
    const hoursMatch = duration.match(/(\d+)\s*[hH]/);
    const minutesMatch = duration.match(/(\d+)\s*[mM][in]*/);

    let minutes = 0;
    if (hoursMatch) {
      minutes += parseInt(hoursMatch[1], 10) * 60;
    }
    if (minutesMatch) {
      minutes += parseInt(minutesMatch[1], 10);
    }

    return minutes;
  }
}
